"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieManager = void 0;
const Cookies = __importStar(require("./cookies"));
class CookieManager {
    static loadPreferences() {
        const saved = localStorage.getItem(this.STORAGE_KEY);
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                return {
                    necessary: true,
                    analytics: parsed.analytics || false,
                    marketing: parsed.marketing || false,
                    preferences: parsed.preferences || false,
                };
            }
            catch (error) {
                console.error("Error parsing saved preferences:", error);
            }
        }
        return {
            necessary: true,
            analytics: false,
            marketing: false,
            preferences: false,
        };
    }
    static savePreferences(preferences) {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(preferences));
    }
    static applyPreferences(preferences) {
        var _a, _b, _c, _d;
        if (preferences.analytics) {
            (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, "consent", "update", {
                analytics_storage: "granted",
            });
        }
        else {
            (_b = window.gtag) === null || _b === void 0 ? void 0 : _b.call(window, "consent", "update", {
                analytics_storage: "denied",
            });
            this.clearAnalyticsCookies();
        }
        if (preferences.marketing) {
            (_c = window.gtag) === null || _c === void 0 ? void 0 : _c.call(window, "consent", "update", {
                ad_storage: "granted",
            });
        }
        else {
            (_d = window.gtag) === null || _d === void 0 ? void 0 : _d.call(window, "consent", "update", {
                ad_storage: "denied",
            });
            this.clearMarketingCookies();
        }
        if (preferences.preferences) {
        }
        else {
            Cookies.remove("mapBoundsEast");
            Cookies.remove("mapBoundsNorth");
            Cookies.remove("mapBoundsSouth");
            Cookies.remove("mapBoundsWest");
            localStorage.removeItem("sessionsListScrollPosition");
            localStorage.removeItem("lastSelectedMobileTimeRange");
            localStorage.removeItem("lastSelectedTimeRange");
        }
        this.dispatchConsentChangeEvent();
    }
    /**
     * Returns cookie names to clear for Google Analytics.
     * Includes base GA cookies and any _ga* cookies present (e.g. _ga_MEASUREMENTID from GA4),
     * so the list stays in sync with tags in GTM without code changes.
     */
    static getAnalyticsCookieNames() {
        const base = ["_ga", "_gid", "_gat"];
        if (typeof document === "undefined" || !document.cookie) {
            return base;
        }
        const fromPage = document.cookie
            .split("; ")
            .map((s) => s.split("=")[0].trim())
            .filter((name) => name.startsWith("_ga"));
        return Array.from(new Set([...base, ...fromPage]));
    }
    static clearAnalyticsCookies() {
        const domains = ["", ".aircasting.org", ".google.com", ".google.pl"];
        const analyticsCookies = this.getAnalyticsCookieNames();
        domains.forEach((domain) => {
            analyticsCookies.forEach((cookieName) => {
                if (domain === "") {
                    Cookies.remove(cookieName);
                }
                else {
                    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; path=/`;
                }
            });
        });
        Object.keys(localStorage).forEach((key) => {
            if (key.startsWith("_ga") || key.startsWith("ga_")) {
                localStorage.removeItem(key);
            }
        });
    }
    static clearMarketingCookies() {
        const domains = ["", ".aircasting.org", ".google.com", ".google.pl"];
        const marketingCookies = [
            "_gcl_au",
            "AEC",
            "APISID",
            "__Secure-1PAPISID",
            "__Secure-1PSID",
            "__Secure-3PAPISID",
            "__Secure-3PSID",
            "__Secure-ENID",
        ];
        domains.forEach((domain) => {
            marketingCookies.forEach((cookieName) => {
                if (domain === "") {
                    Cookies.remove(cookieName);
                }
                else {
                    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; path=/`;
                }
            });
        });
        Object.keys(localStorage).forEach((key) => {
            if (key.startsWith("_gcl") || key.startsWith("ads_")) {
                localStorage.removeItem(key);
            }
        });
    }
    static dispatchConsentChangeEvent() {
        if (typeof window !== "undefined") {
            window.dispatchEvent(new CustomEvent("cookieConsentChanged"));
        }
    }
    static enableAll() {
        const allEnabled = {
            necessary: true,
            analytics: true,
            marketing: true,
            preferences: true,
        };
        this.savePreferences(allEnabled);
        this.applyPreferences(allEnabled);
    }
    static disableNonNecessary() {
        const onlyNecessary = {
            necessary: true,
            analytics: false,
            marketing: false,
            preferences: false,
        };
        this.savePreferences(onlyNecessary);
        this.applyPreferences(onlyNecessary);
    }
    static hasPreferences() {
        return localStorage.getItem(this.STORAGE_KEY) !== null;
    }
    static updatePreference(key, value) {
        const preferences = this.loadPreferences();
        preferences[key] = value;
        this.savePreferences(preferences);
        this.applyPreferences(preferences);
    }
    static arePreferenceCookiesAllowed() {
        const preferences = this.loadPreferences();
        return preferences.preferences;
    }
}
exports.CookieManager = CookieManager;
CookieManager.STORAGE_KEY = "cookiePreferences";
